import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import MainListItems from "./Component/drawer";
import Avatar from "@material-ui/core/Avatar";
import { white } from "material-ui/styles/colors";
import Navbar from "./Component/tabDrawer/Navbar";
import DashboardComponent from "../dashboard/dashboardComponent";
// import UserComponent from "../User/User"
import Drop from "./Component/passwordPopUp";
import User from "../User/User";
import Hastag from "../Hastag/Hastag";
import Nftseller from "../Nftseller/Nftseller";
import Nftbuyer from "../Nftbuyer/Nftbuyer";
import Notificationdrop from "./Component/Notificationdrop";
import Utility from "../../utility";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { dispatchAction } from "../../utility";
import { connect } from "react-redux";
import Terms from "./Component/termAndConditon/terms";
import Utils from "../../utility";
import { totalNftSoldMetricService } from "../../services/index";
import { totalVideoMetricService } from "../../services/index";
import { totalRevenueMetricService } from "../../services/index";
import { totalAccountsCreatedService } from "../../services/index";
import { useTheme } from "@material-ui/styles";

const drawerWidth = 195;

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    width: "auto",
    paddingLeft: 0,
    paddingRight: 0,
  },
  toolbar: {
    paddingRight: 24,
    "@media (min-width: 768px) and (max-width: 1024px)": {
      paddingRight: 2,
      paddingLeft: "3px",
    },
  },

  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    // zIndex: 0,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // "@media(min-width: 768px) and (max-width: 960px)":{
    //   zIndex: theme.zIndex.drawer + 1,
    // }
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(106.5% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "@media (min-width: 1500px)" : {
      width: `calc(105% - 225px)`
    }
  },
  menuButton: {
    marginLeft: -12,
    marginBottom: 15,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 30,
  },

  drawerPaper: {
    position: "absolute",
    whiteSpace: "nowrap",
    width: drawerWidth,
    background: "#001441",
    zIndex: 1201,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "@media (min-width: 768px) and (max-width: 1024px)": {
      display: "none",
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: "70px",
      // zIndex: 0,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflowX: "hidden",
    backgroundColor: "#F6F6F6",
  },
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(0),
    marginLeft: theme.spacing(13),
    paddingRight: theme.spacing(20),
  },

  container1: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(0),
    marginLeft: theme.spacing(13),
    paddingRight: theme.spacing(20),
  },
  fixedHeight: {
    width: "auto",
    height: 200,
  },
  link: {
    marginTop: theme.spacing(-6),
    marginBottom: theme.spacing(1),
  },
  // Avatar: {
  //   maxHeight: 25,
  //   maxWidth: 25,
  // },
  icon: {
    marginRight: theme.spacing(1),
  },
  iconbutton: {
    marginRight: theme.spacing(0),
  },

  container2: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridGap: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(0),
    textAlign: "center",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    marginBottom: theme.spacing(0),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },

  Card: {
    maxHeight: 20,
  },
  profileicon: {
    "&:hover": {
      backgroundColor: "unset",
    },
  },
}));
const mapStateToProps = (state) => {
  return { user: state.user };
};
function Home(props) {
  const history = useHistory();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [videoMetric, setVideoMetric] = React.useState();
  const [nftSoldMetric, setNftSoldMetric] = React.useState();
  const [revenueMetric, setRevenueMetric] = React.useState();
  const [accountCreated, setAccountCreated] = React.useState();

  useEffect(() => {
    if (props.user.IsLoggedIn === false) {
      return history.push("/");
    }
    videoMetricGraph();
    nftSoldMetricGraph();
    revenueMetricGraph();
    accountCreatedGraph();
  }, []);

  async function videoMetricGraph() {
    let [error, videoMetricGraph] = await Utils.parseResponse(
      totalVideoMetricService.getTotalVideoMetric()
    );
    if (error || !videoMetricGraph) return;

    setVideoMetric(videoMetricGraph);
  }

  async function nftSoldMetricGraph() {
    let [error, nftSoldMetricGraph] = await Utils.parseResponse(
      totalNftSoldMetricService.getTotalNftSoldMetric()
    );
    if (error || !nftSoldMetricGraph) return;

    setNftSoldMetric(nftSoldMetricGraph);
  }

  async function revenueMetricGraph() {
    let [error, revenueMetricGraph] = await Utils.parseResponse(
      totalRevenueMetricService.getTotalRevenueMetric()
    );
    if (error || !revenueMetricGraph) return;

    setRevenueMetric(revenueMetricGraph);
  }

  async function accountCreatedGraph() {
    let [error, accountCreatedGraph] = await Utils.parseResponse(
      totalAccountsCreatedService.getTotalAccountsCreated()
    );
    if (error || !accountCreatedGraph) return;

    setAccountCreated(accountCreatedGraph);
  }
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        elevation={0}
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
        style={{background: white}}
      >
        <Toolbar className={classes.toolbar}>
          <div style={{ width: "100%", height: "40%" }}>
            <Box display="flex" p={-2} ml={11}>
              <Navbar id="tab-tab" setOpen={setOpen}/>
              <Box boxShadow={0} p={1} flexGrow={1}>
                <img
                  src="/RealsNFT.svg"
                  alt="logo"
                  className="w-152 p-152 m-152"
                />
              </Box>
              <Box boxShadow={0} className="m-155 p-155">
                <Notificationdrop user={props?.user} />
              </Box>
              <Box boxShadow={0} pr={1}>
                <IconButton color="black" className={classes.profileicon}>
                  <Drop user={props?.user} />
                </IconButton>
              </Box>
            </Box>
          </div>
          
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
      >
        <ListItem>
          <ListItemIcon>
            <div className={classes.toolbarIcon}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => setOpen(!open)}
                edge="start"
                className={classes.menuButton}
              >
                <MenuIcon style={{ fill: "	#FFFFFF" }} />
              </IconButton>
            </div>
          </ListItemIcon>
        </ListItem>
        <List>
          {/* { MainListItems()} */}
          {open ? (
            <MainListItems setOpen={setOpen} />
          ) : (
            <div className="homeImagesParent">
              <div
                className={
                  window.location.pathname.includes("/home/dashboard")
                    ? "homeBoardImage"
                    : "homeBoard-NonselectedImage"
                }
              >
                <img
                  onClick={() => history.push("/home/dashboard")}
                  src="/images/Dashboard.svg"
                  alt=""
                />
              </div>

              <div
                className={
                  window.location.pathname.includes("/home/users")
                    ? "homeUserImage"
                    : "homeUser-NonselectedImage"
                }
              >
                <img
                  onClick={() => history.push("/home/users")}
                  src="/images/user_icon.svg"
                  alt=""
                />
              </div>

              {/* <div className="homePromoImage">
                <a href="#">
                  <img src="/images/promotion.svg" alt="" />
                </a>
              </div> */}
              <div
                className={
                  window.location.pathname.includes("/home/terms")
                    ? "homeUserImage"
                    : "homeUser-NonselectedImage"
                }
              >
                <img
                  onClick={() => history.push("/home/terms")}
                  src="/images/setting.svg"
                  alt=""
                />
              </div>
            </div>
          )}
        </List>
      </Drawer>
      {window.location.pathname.includes("dashboard") ? (
        <DashboardComponent
          nftSoldMetric={nftSoldMetric}
          videoMetric={videoMetric}
          revenueMetric={revenueMetric}
          accountCreated={accountCreated}
        />
      ) : (
        ""
      )}
      {window.location.pathname.includes("users") ? (
        <User user={props?.user} />
      ) : (
        ""
      )}
      {window.location.pathname.includes("hastag") ? <Hastag /> : ""}
      {window.location.pathname.includes("nftseller") ? <Nftseller /> : ""}
      {window.location.pathname.includes("nftbuyer") ? <Nftbuyer /> : ""}
      {window.location.pathname.includes("terms") ? <Terms /> : ""}
    </div>
  );
}
export default connect(mapStateToProps, { dispatchAction })(Home);
